import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Aktifkan PWA service worker
serviceWorkerRegistration.register({
  onSuccess: () => console.log('MIG Security: App siap offline'),
  onUpdate: (registration) => {
    console.log('MIG Security: Update tersedia');
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});
